export class FBUserModel {
  public id: string;
  public userId: string;
  public name: string;
  public email: string;
  public expiresIn: number;
}